<!--
 * @Author: your name
 * @Date: 2020-12-28 14:14:26
 * @LastEditTime: 2020-12-28 14:23:29
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /yunlizhi/货主端1.0/src/pages/orderManage/orderManageDetail/components/CarGps.vue
-->
<template>
  <div class="OrderStatus-root car-gps">
    <info-box title="订单状态">
      <template slot="mainContent">
        <a-descriptions-item >
          <app-map-gps
            ref="appMapGps"
            class="app-map-gps"
            :start-time="formatStartTime(startTime)"
            :end-time="endTime"
            :driver-phone="orderData.waybillList && orderData.waybillList[0] && orderData.waybillList[0].driverPhone || orderData.driverPhone"
            :driver-name="orderData.driverName"
            :shipping-order-no="shippingOrderNo"
            :license-plate="orderData.licensePlate"
            :is-waybill="true"
            :equipment-codes="equipmentCodes"
            :site-start="siteStart"
            :site-end="siteEnd"
            :waybill-status="waybillStatus"
            :waybill-list="waybillList"
            :is-demo="isDemo"
            :waybill-codes="waybillCodes"
            :is-demo-account="orderData.ext && orderData.ext.demoData"
          />
        </a-descriptions-item>
      </template>
      <div slot="titleContent">
        <span class="title">轨迹追踪</span>
        <a-button class="track_btn" @click="handleTrack">查看完整轨迹</a-button>
      </div>
    </info-box>
  </div>
</template>

<script>
import appMapGps from "@/components/app-map-gps";
import moment from "moment";
import { WaybillStatusText } from "@/pages/orderManage/constant.js";
import InfoBox from "./InfoBox.vue";

export default {
  name: "CarGps",
  components: {
    InfoBox,
    appMapGps,
  },
  props: {
    waybillList: {
      type: Array,
      default: () => [],
    },
    startTime: {
      type: [String, Number],
      default: "",
    },
    orderData: {
      type: Object,
      default: () => {},
    },
    orderDetail: {
      type: Object,
      default: () => {},
    },
    dispatch: {
      type: Object,
      default: () => {},
    },
    isDemo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: "",
      signingTime:''
    };
  },
  computed: {
    endTime() {
      let endTime = "";
      if (this.waybillList.length > 0) {
        endTime = this.waybillList.filter((item) => item.id === this.value)[0]
          .signingTime;
      }
      return this.formatDate(endTime);
    },
    siteStart() {
      const result = [];
      if (this.waybillList.length > 0) {
        // result = this.waybillList.filter((item) => item.id === this.value)[0]
        //   .shippingAddress;
        this.waybillList.forEach(item => {
          result.push(item.shippingAddress)
        })
      }
      return result;
    },
    siteEnd() {
      const result = []
      const waybillList = this.dispatch?.waybillList || []
      waybillList.forEach(item => {
        const { receivingAddress } = item
        result.push({
          address: receivingAddress.receivingAddressName,
          longitude: receivingAddress.longitude,
          latitude: receivingAddress.latitude,
          type: 1,
          status: this.getStatusText(item.waybillStatus)
        })
      })
      return result;
    },
    waybillStatus(){
      let result = 1;
      if (this.waybillList.length > 0) {
        result = this.waybillList.filter((item) => item.id === this.value)[0]
          .waybillStatus;
      }
      return result;
    },
    waybillCodes() {
      return this.waybillList.map(item => item.waybillCode)
    },
    equipmentCodes(){
      if( this.dispatch?.ext?.equipmentCode) {
        return  this.dispatch?.ext?.equipmentCode?.split(',')
      }
      return []
    },
    shippingOrderNo(){
      return this.orderData?.shippingOrderNo || undefined
    }
  },
  watch: {
    waybillList: {
      handler(waybillList) {
        this.value = (waybillList[0] && waybillList[0].id) || "";
      },
    },
  },

  created() {},
  mounted() {},
  methods: {
    getStatusText(val) {
      let result = "-";
      WaybillStatusText.map((item) => {
        if (item.value === val) {
          result = item.label;
        }
        return item
      });
      return result;
    },
    handleChange(value) {
      this.value = value;
      this.$refs.appMapGps.queryOrderTransport();
    },
    formatDate(time) {
      if (!time) {
        return moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      }
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatStartTime(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      }
      return "";
    },
    handleTrack(){
      // 查看完整轨迹
      const {endStations=[],startStations=[]} = this.orderDetail||{};
      this.$router.push({
        path:'/inTransitGoods',
        query:{
          waybillCode:this.waybillCodes[0],
          startName:startStations[0].stationName,
          endName:endStations[0][0].stationName,
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
 .app-map-gps {
  width: 100%;
}
</style>
<style lang="less">
.car-gps {
  .ant-descriptions-item > span {
    display: block;
  }
}
.select-wrapper {
  width: 260px;
  float: right;
}
.track_btn{
  margin-left: 24px;
}
</style>
